import { ToolsPanelToggleButton } from "../controls";
import { Typography } from "@mui/material";
import {
    useAppSidePanelContextProvider
} from "../../../shared/contexts/app-side-panel-context-provider/components/AppSidePanelContextProvider";
import { useEffect } from "react";

export function CustomImpliedVolatilityToggleButton() {
    const {
        selectedPortfolio,
        updateSelectedPortfolio,
        saveSelectedPortfolio,
    } = useAppSidePanelContextProvider();

    const value = selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null
        ? selectedPortfolio.portfolioSettings.isCustomImpliedVolatilityEnabled
        : false;

    useEffect(() => {
    }, [selectedPortfolio]);

    const onChange = async () => {
        const newValue = !value;

        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null) {
            selectedPortfolio.portfolioSettings.isCustomImpliedVolatilityEnabled = newValue;
            updateSelectedPortfolio();
            saveSelectedPortfolio();
        }
    }
    
    return (
        <ToolsPanelToggleButton
            isActivated={value}
            setIsActivated={onChange}
            tooltipTextWhenActivated="Use real market IV"
            tooltipTextWhenDeactivated="Use custom IV"
        >
            <Typography sx={{ fontSize: '14px', fontWeight: 'bold'}}>
                IV
            </Typography>
        </ToolsPanelToggleButton>
    )
}